import styled from 'styled-components';

export const TableWrapper = styled.div.attrs({
  className: 'col-12 mt-3 px-0'
})`
  border: 1px solid #E0E0E0;
  border-radius: 6px;
`

export const PageWrapper = styled.div.attrs(({ isMobile }) => ({
  className: 'p-4'
}))``

export const FilterRow = styled.div.attrs({
  className: 'col-12 p-3 mt-0'
})`
  display: flex;
  flex-direction: row;
`

export const FilterCol = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
`